//recurrence type
export const recurTypeEnum = Object.freeze({
  DAILY: 1,
  WEEKLY: 2,
  MONTHLY: 3,
});

//recurrence range type
export const recurRangeTypeEnum = Object.freeze({
  DATE_FINALIZE: 1,
  DATE_AFTER_OF: 2,
});

//valid workdays
export const validWeekDays = [0, 1, 2, 3, 4, 5]; //monday to saturday

//Operation mode
export const opMode = Object.freeze({
  INSERT: 'I',
  EDIT: 'E',
});
